import React from "react";
import Globals from "../../api";
import "./footer.scss";
import { Helmet } from "react-helmet";
import { Nav, NavDropdown, Link } from "react-bootstrap";

import apple_app from "../../assets/img/apple_app.png";
import android_app from "../../assets/img/android_app.png";
import wd_logo_white from "../../assets/img/svg/wd_logo_w.svg";

export default class Footer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      footerData: [],
      footerLinkData: [],
    };
  }
  componentDidMount() {
    const FooterConurl = Globals.Desktop_footer_based_api;
    fetch(FooterConurl)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          footerData: data.NavigationMenu.Items,
        });
      });
    this.getHomeDetails();
  }
  getHomeDetails() {
    const FooterLinks = Globals.language_based_api;
    fetch(FooterLinks)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          footerLinkData: data.Contents[4].Items,
        });
      });
  }
  render() {
    let footData = this.state.footerLinkData;
    let footerItems = footData.map((item, i) => (
      <li key={i}>
        <a href={item.DefaultUrl}>{item.Text}</a>
      </li>
    ));
    let _navmenu = this.state.footerData;
    const NavMenu = _navmenu.map((item, i) => (
        <div className="footer_widget" key={i}>
          <h3>{item.Text}</h3>
          <ul className="footer_menus">
            {item.Items.map((item, i) => (
              <li key={i}>
                <Nav.Link href={item.DefaultUrl}>{item.Text}</Nav.Link>
              </li>
            ))}
          </ul>
        </div>
    ));

    return (
      <>
      <Helmet>
      
      <script src= "/js/vuukle.js"  id="vuukle_script"></script>
      <script src= "/js/adgebra_end.js" ></script>
      </Helmet>
           
      {!window.location.pathname.includes("biodata-maker") && (
        <div data-type="_mgwidget" data-widget-id="1630928"></div>
      )}

      


      {(() => {
        let regex = /.{0,}([0-9])(\.html|\.htm).{0,}/;
                if (regex.test(window.location.href)) {
                  return (
                    <div className="container">    
                    <div id='vuukle-comments'></div> 
                    </div>
                  )
                } 
              })()}

      <div className="footer_seciton">
        <div className="footer_top_sect">
          <div className="container">
            <div className="apps_link">
              <a href="https://play.google.com/store/apps/details?id=com.webdunia.app&hl=en" aria-label="Android app">
                <img src={android_app} alt="Android app" title="Android app" width="180" height="53" />
              </a>
              <a href="https://apps.apple.com/in/app/webdunia/id1599507309"  aria-label="iOS app">
                <img src={apple_app} alt="iOS app" title="iOS app" width="180" height="53" />
              </a>
            </div>
          </div>
        </div>
        <div className="footer_sect">
          <div className="container">
            <div className="row">
              <div className="col-lg-2">
                <div className="footer_about">
                  <span>
                    <img src={wd_logo_white} alt="Webdunia" title="Webdunia" width="196" height="102" />
                  </span>
                  <div className="f_social_block">
                    <span>FOLLOW US ON</span>
                    <ul className="f_follow_us">
                      <li>
                        <a
                          href="https://www.facebook.com/WebduniaEng"
                          className="f_fb_icon" aria-label="facebook"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://twitter.com/WebduniaHindi"
                          className="f_tw_icon" aria-label="twitter"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/@WebduniaEnglish"
                          className="f_yt_icon" aria-label="youtube"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/webduniaenglish/"
                          className="f_inst_icon" aria-label="instagram"
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-10">
                <div className="foot_menu_list">{NavMenu}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_bottom_sect">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <ul className="footer_menu_link">{footerItems}</ul>
              </div>
              <div className="col-lg-4">
                <p className="copyright_text">Copyright {new Date().getFullYear()}, Webdunia.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    );
  }
}
